/**
 * Business categories — the dropdown options shown during business signup,
 * upgrade and edit. Mirrors the shape of `serviceCategories` so dropdowns
 * across the app stay consistent.
 */
export const BUSINESS_CATEGORIES = [
    { id: "beauty",       label: "Beauty & Wellness" },
    { id: "events",       label: "Events & Entertainment" },
    { id: "food",         label: "Food & Catering" },
    { id: "photography",  label: "Photography & Video" },
    { id: "home",         label: "Home Services" },
    { id: "fashion",      label: "Fashion & Style" },
    { id: "tech",         label: "Tech & Digital" },
    { id: "health",       label: "Health & Fitness" },
    { id: "education",    label: "Education & Coaching" },
    { id: "logistics",    label: "Logistics & Transport" },
    { id: "professional", label: "Professional Services" },
    { id: "retail",       label: "Retail & Shopping" },
    { id: "other",        label: "Other (specify)" },
];

export const findBusinessCategoryById = (id) =>
    BUSINESS_CATEGORIES.find((c) => c.id === id) || null;
